import React from 'react';
import { Cell, Pie, PieChart } from 'recharts';
import { toPercentage } from '@/utils/text';

interface Props {
  percent: number;
}

const GAUGE_WIDTH = 200;
const RING_OUTER_RADIUS = 99;
const RING_INNER_RADIUS = 69;
const RING_CORNER_RADIUS = 7;
const HALF_CIRCLE_START = 180;
const MIN_DRAWN_PERCENT = 2;
const NO_MARGIN = { top: 0, right: 0, bottom: 0, left: 0 };

export const AttendanceGauge: React.FC<Props> = ({ percent }) => {
  const drawnPercent = Math.max(percent, MIN_DRAWN_PERCENT);
  const drawnAngle = (drawnPercent / 100) * HALF_CIRCLE_START;
  const innerArcLength = ((drawnAngle * Math.PI) / 180) * RING_INNER_RADIUS;
  const ring = {
    data: [{ value: 1 }],
    cx: GAUGE_WIDTH / 2,
    cy: RING_OUTER_RADIUS,
    innerRadius: RING_INNER_RADIUS,
    outerRadius: RING_OUTER_RADIUS,
    startAngle: HALF_CIRCLE_START,
    dataKey: 'value',
    strokeWidth: 0,
    isAnimationActive: false,
  };

  return (
    <div className="relative h-[65px] w-[128px] shrink-0 md:h-[104px] md:w-[200px]">
      <div className="origin-top-left scale-[0.64] md:scale-100">
        <PieChart
          width={GAUGE_WIDTH}
          height={RING_OUTER_RADIUS + 1}
          margin={NO_MARGIN}
        >
          <Pie {...ring} endAngle={0} cornerRadius={RING_CORNER_RADIUS}>
            <Cell fill="var(--color-on-primary-surface)" />
          </Pie>
          <Pie
            {...ring}
            endAngle={HALF_CIRCLE_START - drawnAngle}
            cornerRadius={Math.min(RING_CORNER_RADIUS, innerArcLength / 2)}
          >
            <Cell fill="var(--color-primary)" />
          </Pie>
        </PieChart>
      </div>
      <span className="absolute inset-x-0 bottom-0 text-center text-[20px] leading-[25px] font-semibold text-primary md:text-[32px] md:leading-[40px]">
        {toPercentage(percent)}
      </span>
    </div>
  );
};
